import React, { useState } from 'react';
import { Text, ActionIcon, Menu } from '@mantine/core';
import { IconFilter } from '@tabler/icons-react';
import { TableHeaderWrapper } from '../TableHeaderWrapper';
import { StoreFilterTreeMenu } from './StoreFilterTreeMenu';

interface StoreColumnHeaderProps {
    readonly currentOperationsAreaIds: string[] | null;
    readonly currentDivisionIds: string[] | null;
    readonly currentStoreIds: string[] | null;
    readonly onChange: (
        operationsAreaIds: string[] | null,
        divisionIds: string[] | null,
        storeIds: string[] | null,
    ) => void;
}

export function StoreColumnHeader({
    currentOperationsAreaIds,
    currentDivisionIds,
    currentStoreIds,
    onChange,
}: StoreColumnHeaderProps) {
    const [isOpen, setIsOpen] = useState(false);

    const isFilterActive = Boolean(
        (currentOperationsAreaIds && currentOperationsAreaIds.length > 0) ||
            (currentDivisionIds && currentDivisionIds.length > 0) ||
            (currentStoreIds && currentStoreIds.length > 0),
    );

    return (
        <TableHeaderWrapper>
            <Menu
                closeOnItemClick={false}
                shadow="md"
                width={450}
                opened={isOpen}
                onChange={setIsOpen}
                position="bottom-start"
            >
                <Menu.Target>
                    <div className="flex">
                        <Text span>Store</Text>
                        <ActionIcon
                            variant="transparent"
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                setIsOpen(o => !o);
                            }}
                            className="flex-shrink-0"
                        >
                            <IconFilter
                                size={16}
                                color={isFilterActive ? '#00539f' : 'gray'}
                            />
                        </ActionIcon>
                    </div>
                </Menu.Target>
                <Menu.Dropdown>
                    <StoreFilterTreeMenu
                        currentOperationsAreaIds={currentOperationsAreaIds}
                        currentDivisionIds={currentDivisionIds}
                        currentStoreIds={currentStoreIds}
                        onChange={onChange}
                        setIsOpen={setIsOpen}
                        isOpen={isOpen}
                    />
                </Menu.Dropdown>
            </Menu>
        </TableHeaderWrapper>
    );
}

StoreColumnHeader.displayName = 'StoreColumnHeader';
